module.exports = __webpack_public_path__ + "static/img/paytm.b70b494.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/footer/img/paytm.svg
// module id = q1dI
// module chunks = 42